var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-wrap"},[_c('img',{staticClass:"header-bg",attrs:{"src":_vm.headImg,"alt":_vm.$t('日行一善')}}),_c('div',{staticClass:"header-content"},[_c('StampBalance')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }